














































































































































































import { PaymentMeansEnum } from "@/shared/models/enums.type";
import { Component, Prop, PropSync, Vue, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { PaymentMean } from "@/shared/models/paymentMean";
import { CardType } from "@/shared/models/cardType";
import NumericInputImproved from "@/components/numbers/NumericInputImproved.vue";
import * as _ from "lodash";
import { PaymentMeansAdditionalDetailsModel } from "./FinancialDocumentFormParts/models";

@Component({ components: { NumericInputImproved } })
export default class FinancialDocumentPaymentMeansAdditionalDetailsModal extends Vue {
  isOpen = false;

  @PropSync("paymentMeansAdditionalDetails")
  syncDetails?: PaymentMeansAdditionalDetailsModel[];

  internalDetails: PaymentMeansAdditionalDetailsModel[] = [];

  @Prop() formalCurrencyId?: number;
  @Prop() formalCurrencyISO3?: string;

  @Prop({ default: 0 }) amountDue?: number;
  @Prop({ default: 1 }) conversionRate?: number;

  @Prop() locked?: boolean;

  isFormValid = false;
  fkey = 0;

  paymentMeansEnum = PaymentMeansEnum;

  getAvailableCardTypes(detail: { cardTypeId?: number }): CardType[] {
    if (!this.cardTypes) return [];

    return this.cardTypes.filter(c => {
      if (detail.cardTypeId === c.id) return true;
      return !c.name.includes('- VCC');
    });
  }

  get amountDueRounded() {
    const rounded = _.round(this.amountDue ?? 0, 2);

    // because JS has signed zeros
    return rounded === 0 ? 0 : rounded;
  }

  get allowedCurrencies() {
    return [
      {
        id: this.formalCurrencyId,
        isoCode: this.formalCurrencyISO3,
      },
    ];
  }

  get invoiceUnpaidTotal() {
    return (
      (this.amountDueRounded ?? 0) -
      (this.internalDetails.reduce((sum, x) => sum + (x.amount ?? 0), 0) ?? 0)
    );
  }

  get invoiceUnpaidTotalRounded() {
    const rounded = _.round(this.invoiceUnpaidTotal, 2);

    // because JS has signed zeros
    return rounded === 0 ? 0 : rounded;
  }

  addDetail() {
    this.internalDetails.push({
      id: 0,
      paymentMeansId: null,
      cardTypeId: null,
      amount: null,
      currencyId: this.formalCurrencyId ?? null,
    });
  }

  async created() {
    const promises = [];

    if ((this.paymentMeans?.length ?? 0) === 0 && this.refreshPaymentMeans) {
      promises.push(this.refreshPaymentMeans());
    }

    if ((this.cardTypes?.length ?? 0) === 0 && this.refreshCardTypes) {
      promises.push(this.refreshCardTypes());
    }

    await Promise.all(promises);
  }

  mounted() {
    this.internalDetails = _.cloneDeep(this.syncDetails ?? []);
    this.fkey++;
  }

  get rules() {
    return {
      required: (value: any) =>
        !!value || this.$t("Validation.Required").toString(),
      mustBeZero: (value: any) => 
        value === 0 || this.$t("Validation.MustBeZero")
    };
  }

  @Watch("isOpen")
  isOpenWatch(fresh: boolean) {
    if (fresh) {
      this.fkey++;
      this.internalDetails = _.cloneDeep(this.syncDetails ?? []);
    }
  }

  accept() {
    this.syncDetails = _.cloneDeep(this.internalDetails);
    this.isOpen = false;
  }

  cancel() {
    this.internalDetails = _.cloneDeep(this.syncDetails ?? []);
    this.isOpen = false;
  }

  get buttonColor() {
    return this.isValid ? "primary" : "error";
  }

  get isValid() {
    return this.isFormValid && this.invoiceUnpaidTotalRounded === 0;
  }

  getPaymentMeanBaseId(id: number) {
    return this.paymentMeans?.find((e) => e.id === id)?.paymentMeanBaseId;
  }

  // prettier-ignore
  @Action("codebooks/refreshPaymentMeans") refreshPaymentMeans?: () => Promise<void>;
  @Getter("codebooks/paymentMeans") paymentMeans?: PaymentMean[];
  @Action("codebooks/refreshCardTypes") refreshCardTypes?: () => Promise<void>;
  @Getter("codebooks/cardTypes") cardTypes?: CardType[];
  @Getter("appParams/isCardTypeRequiredForCardPaymentMeans")
  isCardTypeRequiredForCardPaymentMeans?: boolean;
}
